import React from 'react'
import {
    ContainerFluid,Container,ContainerX,ContainerFluidX,ContainerFluidY,HeadingText,
    DescText 
} from './SectionAComponent.style';
function SectionAComponentHome() {
  return (
    <div className=''>
        <ContainerFluidY></ContainerFluidY>
        <ContainerFluid>
            <Container>
                <div className='row '>
                    <div className='col s12 m12 l6 center'>
                        <img width="66%"  style={{
                        }}  src="https://res.cloudinary.com/yalla-ng/image/upload/v1657628717/re-brand/Group_791_hcy144.svg" alt=""/>
                    </div>
                    <div className='col s12 m12 l6 '>
                        <Container>
                        <div className='row mt-100'>
                            <div className='col s12 m12 l11 mt-100'>
                                <HeadingText>
                                    Mutually beneficial
                                    Investments
                                </HeadingText>
                                
                            </div>
                            <div className='col s12 m12 l9'>
                                <DescText>
                                By saving with us, you not only save towards 
                                your goal, but you know your money is 
                                contributing positively to the society.
                                </DescText>
                            </div>
                           
                        </div>
                        </Container>
                    </div>
                </div>
            </Container>
        </ContainerFluid>
        <ContainerFluidX></ContainerFluidX>
    </div>
  )
}

export default SectionAComponentHome